export default "__VITE_ASSET__D6h1RS7K__"